import React, { useState } from 'react'
import Keyboard from 'react-simple-keyboard'
import 'react-simple-keyboard/build/css/index.css'
import styles from './index.module.scss'

const MODE_SELECT = 'select'
const MODE_EMAIL = 'email'
const MODE_PHONE = 'phone'

const emailLayouts = {
    default: [
        'q w e r t y u i o p',
        'a s d f g h j k l',
        'z x c v b n m @ . _',
        '{backspace} - {space}'
    ]
}

const phoneLayouts = {
    default: [
        '1 2 3',
        '4 5 6',
        '7 8 9',
        '{backspace} 0 +'
    ]
}

const ReceiptContact = ({ onConfirm, onCancel }) => {
    const [mode, setMode] = useState(MODE_SELECT)
    const [value, setValue] = useState('')

    const display = {
        '{backspace}': '⌫',
        '{space}': '_ _'
    }

    const handleKeyPress = (button) => {
        if (button === '{backspace}') {
            setValue(prev => prev.slice(0, -1))
        } else if (button === '{space}') {
            setValue(prev => prev + ' ')
        }
    }

    const handleChange = (input) => {
        setValue(input)
    }

    const handleConfirm = () => {
        if (!value.trim()) return
        onConfirm(mode === MODE_EMAIL ? { client_email: value.trim() } : { client_phone: value.trim() })
    }

    if (mode === MODE_SELECT) {
        return (
            <div className={styles.overlay}>
                <div className={styles.popup}>
                    <div className={styles.title}>Электронный чек</div>
                    <div className={styles.subtitle}>Укажите контакт для получения чека (54-ФЗ)</div>
                    <div className={styles.buttons}>
                        <div className={styles.button} onClick={() => setMode(MODE_EMAIL)}>
                            <div className={styles.buttonIcon}>✉</div>
                            <div className={styles.buttonText}>Email</div>
                        </div>
                        <div className={styles.button} onClick={() => setMode(MODE_PHONE)}>
                            <div className={styles.buttonIcon}>📱</div>
                            <div className={styles.buttonText}>Телефон</div>
                        </div>
                    </div>
                    <div className={styles.skip} onClick={onCancel}>отменить</div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.title}>
                    {mode === MODE_EMAIL ? 'Введите email' : 'Введите телефон'}
                </div>
                <div className={styles.inputRow}>
                    <input
                        className={styles.input}
                        value={value}
                        placeholder={mode === MODE_EMAIL ? 'example@mail.ru' : '+7'}
                        readOnly
                    />
                </div>
                <Keyboard
                    layout={mode === MODE_EMAIL ? emailLayouts : phoneLayouts}
                    layoutName="default"
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    display={display}
                />
                <div className={styles.actions}>
                    <div className={styles.back} onClick={() => { setValue(''); setMode(MODE_SELECT) }}>назад</div>
                    <div
                        className={`${styles.confirm} ${!value.trim() ? styles.disabled : ''}`}
                        onClick={handleConfirm}
                    >
                        OK
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReceiptContact
